import { useEffect, useState } from 'react';

import { store, getInitialState } from '../dataLayer/OpenPixStore.tsx';

// eslint-disable-next-line @typescript-eslint/ban-types
export const useStore = <S extends object>(
  initialOpenPixState = getInitialState(),
): [S, (s: S) => S] => {
  const [storeState, setStoreState] = useState(initialOpenPixState);

  useEffect(() => {
    const listen = () => {
      const state = store.getState();

      setStoreState(state);
    };

    const unsubscribe = store.subscribe(listen);

    return () => {
      unsubscribe();
    };
  });

  const set = (newState: Partial<S> = {}) => {
    const oldState = store.getState();

    const state = store.setState({
      ...oldState,
      ...newState,
    });

    setStoreState(state);
  };

  return [storeState, set];
};
